import { gql } from "@apollo/client";

export const LENSES_QUERY = gql`
  query Lenses {
    lenses {
      id
      key
      name
      status
      scoring
      content
      standards
      isPrimary
      createdAt
      versions {
        id
        key
        name
        content
        standards
        isPrimary
        createdAt
      }
    }
  }
`;

export const GET_COMPLIANCE_LENSES_ADMIN_QUERY = gql`
  query GetComplianceLensesAdmin {
    getComplianceLenses {
      id
      key
      name
      status
      content
      standards
      isPrimary
      createdAt
      versions {
        id
        key
        name
        content
        standards
        isPrimary
        createdAt
      }
    }
  }
`;

export const GET_MASTER_OBLIGATIONS_QUERY = gql`
  query GetMasterObligationsAdmin($assetType: String, $search: String, $limit: Int, $offset: Int) {
    getMasterObligations(
      assetType: $assetType
      search: $search
      scope: GLOBAL
      limit: $limit
      offset: $offset
    ) {
      items {
        id
        assetType
        category
        obligation
        description
        consequenceOfBreach
      }
      totalCount
    }
  }
`;

export const UPDATE_MASTER_OBLIGATION_MUTATION = gql`
  mutation UpdateMasterObligationAdmin($id: ID!, $input: UpdateMasterObligationInput!) {
    updateMasterObligation(id: $id, input: $input) {
      id
      assetType
      category
      obligation
      description
      consequenceOfBreach
    }
  }
`;

export const DELETE_MASTER_OBLIGATION_MUTATION = gql`
  mutation DeleteMasterObligationAdmin($id: ID!) {
    deleteMasterObligation(id: $id)
  }
`;
